// extracted by mini-css-extract-plugin
export default {"right-icon":"search-input_right-icon__Q9afG"};